<template>
  <BaseModal v-model="model" :max-width="450">
    <h2 class="upgrade-modal__text">{{ t('sources.modal.title') }}</h2>
    
    <div class="sources-list">
      <ul>
        <li v-for="source in selectedSources" :key="source.value" class="bg-primary-lighten-1 pills">
          {{ source.text }}
        </li>
      </ul>
    </div>

    <p class="change-sources-text">{{ t('sources.modal.changeDescription') }}</p>
    
    <div class="upgrade-modal__action-container">
      <button class="upgrade-modal__button btn-ok" @click="closeModal">
       {{ t('sources.modal.btnOk') }}
      </button>
    </div>
  </BaseModal>
</template>
<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useStore } from 'vuex';
import BaseModal from '@/components/BaseModal.vue';

const emit = defineEmits(['applyWaveAnimation']);

const store = useStore();
const { t } = useI18n();

const model = computed({
  get: () => store.state.sourcesFirstTimeModal,
  set: (val) => { 
    store.commit('SET_STATE_PROPERTY', {
      property: 'sourcesFirstTimeModal',
      value: val,
    });
  },
});

// Get the selected sources as a list of objects with text (name) and value (id)
const selectedSources = computed(() => {
  const selectedSourceIds = store.state.chatSelectedQuerySources;
  const allSources = [
    ...store.getters.getOptionsListOfDefaultSource,
    ...store.getters.getOptionsListOfOrganizationSource
  ];

  // Handle special case for web search sources that might use a comma-separated format
  return selectedSourceIds.flatMap(sourceId => {
    // If it's a web search source with comma-separated IDs
    if (sourceId.includes('*') || sourceId.includes(',')) {
      const webSearchSource = store.getters.getWebSearchSources;
      return webSearchSource
        ? [{
            value: webSearchSource.value,
            text: webSearchSource.textLabel ? t(webSearchSource.textLabel) : webSearchSource.text
          }]
        : [];
    }

    // Regular source
    const source = allSources.find(s => s.value === sourceId);
    return source
      ? [{
          value: source.value,
          text: source.textLabel ? t(source.textLabel) : source.text
        }]
      : [];
  });
});

const closeModal = () => {
  model.value = false; // Close the modal
};
</script>
<style lang="scss" scoped>
.upgrade-modal {
  &__text {
    margin-top: 2px;
    margin-bottom: 16px;
    font-weight: 700; // Adding bold font weight
  }
  &__action-container {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
    margin-bottom: 16px;
  }
  &__button {
    flex: 0.8;
    min-width: 120px;
    max-width: 150px;
  }
}

.sources-list {
  margin: 16px 0;

  ul {
    list-style-type: none;
    padding-left: 0;

    li {
      margin-bottom: 4px;
    }
  }
}

.change-sources-text {
  margin: 16px 0;
}

.btn-ok {
  padding: 2px 0px;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  height: 30px;
  background-color: #DDDFEA;
  max-width: 100px;
  
}

.pills {
  border-radius: 9999px !important;
  width: 250px;
  margin-top: 6px;
  padding: 3px 16px;
  border-radius: 24px;
  background-color: #E0E7FF;
  color: #1E3A8A;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
